import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2InteractiveToolIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 24 24.005",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 24.005),
    children: [/*#__PURE__*/jsx("path", {
      d: "m3.75 15.117a2.939 2.939 0 0 1 -3-2.873v-8.619a2.939 2.939 0 0 1 3-2.873h16.5a2.939 2.939 0 0 1 3 2.873v8.619a2.8 2.8 0 0 1 -.749 1.9"
    }), /*#__PURE__*/jsx("path", {
      d: "m11.759 23.251-3.688-4.917a1.469 1.469 0 0 1 -.048-1.7 1.469 1.469 0 0 1 2.1-.36l1.628 1.224v-9.327a1.437 1.437 0 0 1 1.444-1.437 1.437 1.437 0 0 1 1.437 1.437v5.746l4 .889a2.873 2.873 0 0 1 2.238 3.065l-.489 5.384z"
    })]
  });
};

export { PM2InteractiveToolIcon };
//# sourceMappingURL=interactive-tool.js.map
